import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class HomeComponent extends Vue {
    mounted() {
        console.info('vue.js HomeComponent is ready');
    }

    currentcount: number = 4;
}
